import Enhancer from '../enhancer.js';
import EnhancerApp from '../enhancer-app.js';
import { throttle } from '../utils/utils';

export default class EqualHeight extends Enhancer {

    selectorAttribute = 'data-equal-height';

    init() {

        window.addEventListener('resize', throttle(() => {
            this.resetHeight();
            this.setHeight();
        }, 100));

        if (this.enabled && this.matchMedia()) {
            this.setHeight();
        }

    }

    resetHeight() {
        this.getAll(`[${this.selectorAttribute}]`).forEach(el => el.style.height = null);
    }

    setHeight() {
        if (this.matchMedia()) {
            for (const groupName in this.elements) {
                this.setHeightForGroup(groupName);
            }
        }
    }

    setHeightForGroup(groupName) {
        const groupElements = this.elements[groupName];
        const heights = groupElements.map(el => {
            const rects = el.getClientRects();

            if (rects.length > 0) {
                return rects[0].height;
            }

            return 0;
        });

        const maxHeight = Math.max(...heights);
        groupElements.forEach(el => el.style.height = maxHeight + 'px');
    }

    matchMedia() {
        const mediaQuery = this.getData('mq');

        if (!mediaQuery)
            return true;

        return window.matchMedia(mediaQuery).matches;
    }

    get enabled() {
        if (this.getData('enabled') !== 'false') {
            return true;
        }

        return false;
    }

    set enabled(value) {
        this.setData('enabled', value);
    }

    get mediaQuery() {
        return this.getData('media-query');
    }

    get elements() {
        return Array.from(this.getAll(`[${this.selectorAttribute}]`)).reduce((map, el) => {
            const number = el.getAttribute(this.selectorAttribute);
            if (!map[number]) {
                map[number] = [];
            }

            map[number].push(el);

            return map;
        }, {});
    }

}

// Enhancers must be registered with a name that is used in the data-enhancer attribute
EnhancerApp.register('EqualHeight', EqualHeight);